<template>
	<div class="r-d-form">
		<div class="box-card">
			<div v-html="content"></div>
		</div>
	</div>
</template>

<script>
	import DOMPurify from 'dompurify';
	export default {
		data() {
			return {
				key: 'about_us',
				content: '',
			};
		},
		mounted() {
			if (this.$route.query.hasOwnProperty('key')) {
			    this.key = this.$route.query.key;
			}
			document.title = this.getTitle(this.key);
			this.loadConfig();
		},
		methods: {
			// 服务详情
			loadConfig() {
				this.$http.get('/index/config?key='+this.key).then(res => {
					this.content = DOMPurify.sanitize(res.data.text);
				}).catch(err => {
					console.error('请求失败', err);
				});
			},
			getTitle(val) {
				let obj = {
					'about_us': '关于昱栎',
					'mianze': '免责声明',
				}
				this.title = obj[val];
				return obj[val]
			},
		}
	};
</script>
<style scoped>
	.r-d-form {
		height: 100vh;
		background-color: #FAFAFA;
		padding-top: 50px;
	}

	.box-card {
		width: 950px;
		margin: 0 auto;
		padding: 50px;
		background-color: #fff;
	}
</style>